export const SALARY = "SALARY";
export const SALARY_SUCCESS = "SALARY_SUCCESS";
export const SALARY_FAILED = "SALARY_FAILED";

export const ADD_SALARY = "ADD_SALARY";
export const ADD_SALARY_SUCCESS = "ADD_SALARY_SUCCESS";
export const ADD_SALARY_FAILED = "ADD_SALARY_FAILED";

export const UPDATE_SALARY = "UPDATE_SALARY";
export const UPDATE_SALARY_SUCCESS = "UPDATE_SALARY_SUCCESS";
export const UPDATE_SALARY_FAILED = "UPDATE_SALARY_FAILED";

export const SALARY_SLIP = "SALARY_SLIP";
export const SALARY_SLIP_SUCCESS = "SALARY_SLIP_SUCCESS";
export const SALARY_SLIP_FAILED = "SALARY_SLIP_FAILED";

export const UPDATE_SALARY_SLIP = "UPDATE_SALARY_SLIP";
export const UPDATE_SALARY_SLIP_SUCCESS = "UPDATE_SALARY_SLIP_SUCCESS";
export const UPDATE_SALARY_SLIP_FAILED = "UPDATE_SALARY_SLIP_FAILED";

export const SALARY_HISTORY = "SALARY_HISTORY";
export const SALARY_HISTORY_SUCCESS = "SALARY_HISTORY_SUCCESS";
export const SALARY_HISTORY_FAILED = "SALARY_HISTORY_FAILED";

export const ADD_SALARY_REVISION = "ADD_SALARY_REVISION";
export const ADD_SALARY_REVISION_SUCCESS = "ADD_SALARY_REVISION_SUCCESS";
export const ADD_SALARY_REVISION_FAILED = "ADD_SALARY_REVISION_FAILED";